import { render } from "./webTrumpet.vue?vue&type=template&id=2035de9c&scoped=true"
import script from "./webTrumpet.vue?vue&type=script&lang=js"
export * from "./webTrumpet.vue?vue&type=script&lang=js"

import "./webTrumpet.vue?vue&type=style&index=0&id=2035de9c&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2035de9c"]])

export default __exports__